import {
  Button,
  Card,
  CardContent,
  Divider,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { FcApproval } from "react-icons/fc";
import "./acknowledgement.css";
import { useNavigate, useParams } from "react-router-dom";
import getEventController from "../Controller/getEvent_controller";

const Acknowledgement = () => {
  const navigate = useNavigate();
  const [registrationData, setRegistrationData] = useState([]);

  const { eventRegistrationID } = useParams();

  console.log(eventRegistrationID);

  //use eventRegistrationID to retrieve info
  useEffect(() => {
    getEventController
      .getRegistrationInfo({ eventRegistrationID })
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure
        // Set eventData directly from the response object
        if (response) {
          setRegistrationData({
            eventName: response.event_name,
            eventStartDate: response.event_start_date,
            eventEndDate: response.event_end_date,
            eventSchedule: response.event_schedules,
            eventVenue: response.event_venue,
            registeredPax: response.pax,
            registrationFee: response.amounts,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching event data:", error);
      });
  }, [eventRegistrationID]);

  return (
    <div className="acknowledgement-page">
      <Card sx={{ margin: 0, boxShadow: 5 }} className="ack-card">
        <CardContent>
          <div className="ack-row-1">
            <FcApproval className="ack-icon" />
          </div>
          <div className="ack-row-2">
            <Typography
              sx={{
                fontSize: 25,
                fontWeight: "bold",
                display: "flex",
                justifyContent: "center",
              }}
              color="black"
            >
              Thank You for your Registration
            </Typography>
          </div>
          <Divider sx={{ borderColor: "black", paddingTop: "10px" }} />
          <div className="ack-row-3">
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
              Registration Details
            </Typography>
            <Card
              sx={{
                border: "1px solid #ccc",
                boxShadow: 3,
                borderRadius: "10px",
                backgroundColor: "#fafafa",
                padding: "16px",
              }}
            >
              <CardContent>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Event Name:</strong> {registrationData.eventName}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Event Date:</strong> {registrationData.eventStartDate}{" "}
                  - {registrationData.eventEndDate}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Event Venue:</strong> {registrationData.eventVenue}
                </Typography>
                {/* <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Event Schedule:</strong>
                </Typography>
                <ul style={{ margin: 0, paddingLeft: "20px" }}>
                  {registrationData.eventSchedule
                    .split(",")
                    .map((schedule, index) => (
                      <li key={index} style={{ marginBottom: "5px" }}>
                        {schedule}
                      </li>
                    ))}
                </ul> */}
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Registered Pax:</strong>{" "}
                  {registrationData.registeredPax}
                </Typography>
              </CardContent>
            </Card>
          </div>

          <div className="ack-row-4">
            <span>Note:</span>
            <br />
            <span style={{ color: "red" }}>
              PPK Secretariat will be in contact soon regarding your payment
              documentations.
            </span>
          </div>
          <div className="ack-row-5">
            <button
              className="download-invoice-button"
              onClick={() => navigate("/my_event")}
            >
              Go to MyEvent
            </button>
            <button
              className="download-invoice-button"
              onClick={() => navigate("/dashboard")}
            >
              Back To HomePage
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Acknowledgement;
